import React from "react";
import styled from "styled-components";
import logo from "../../assets/image/png/devpro-logo.png";
import { INK } from "./tokens";

const OwnershipLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 18px;
  max-width: 100%;
  padding: 16px 20px;
  border-radius: 10px;
  background: ${INK};
  color: #fff !important;
  text-decoration: none;
  margin-bottom: 24px;

  img { width: 88px; height: 88px; object-fit: contain; flex-shrink: 0; }
  strong { display: block; font-size: 15px; line-height: 1.5; }
  span { font-size: 13px; line-height: 1.5; }
  &:hover { text-decoration: underline; color: #fff; }
  &:focus-visible { outline: 3px solid #38bdf8; outline-offset: 4px; }
`;

export default function DevProOwnership() {
  return <OwnershipLink href="https://devpros.com.au/" aria-label="Visit DevPro, our parent AI development company">
    <img src={logo} alt="DevPro" width="88" height="88" loading="lazy" />
    <span><strong>Owned by DevPro</strong>AI development company</span>
  </OwnershipLink>;
}
